var _templateObject;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import { Root, Trigger, Item, Content, Portal } from "@radix-ui/react-dropdown-menu";
import React, { useState } from "react";
import UnstyledButton from "../../components/buttons/UnstyledButton";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { DownCarrotIcon } from "../icons";
import { GlobalCSS } from "@classdojo/web/nessie/stylingLib"; // eslint-disable-next-line no-restricted-imports

import { css } from "@emotion/react";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export function DropdownMenu(_ref) {
  var label = _ref.label,
    trigger = _ref.trigger,
    options = _ref.options,
    color = _ref.color,
    side = _ref.side,
    caret = _ref.caret,
    align = _ref.align,
    disabled = _ref.disabled,
    optionsContainerMaxHeight = _ref.optionsContainerMaxHeight,
    portalContainer = _ref.portalContainer;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  function handleEscape(event) {
    event.stopPropagation();
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  }
  var handleFocusOutside = function handleFocusOutside(e) {
    return e.preventDefault();
  };
  return (
    // this on key down is necessary to handle the escape to close
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      onKeyDown: handleEscape,
      children: [_jsx(GlobalCSS, {
        styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          [data-radix-popper-content-wrapper]:focus-within {\n            z-index: 1000 !important;\n          }\n        "])))
      }), _jsxs(Root, {
        open: isOpen,
        onOpenChange: function onOpenChange() {
          return setIsOpen(!isOpen);
        },
        modal: false,
        children: [_jsx(Trigger, {
          sx: DropdownMenuTriggerButtonStyles,
          asChild: true,
          disabled: disabled,
          children: _jsxs(UnstyledButton, {
            sx: _objectSpread(_objectSpread({}, DropdownMenuTriggerButtonStyles), {}, {
              color: color
            }),
            type: "button",
            "aria-label": label,
            "aria-expanded": isOpen,
            disabled: disabled,
            onKeyDown: function onKeyDown(e) {
              // without this, the click with enter also clicks on the first option and never opens the options
              if (!isOpen && e.key === "Enter") {
                e.preventDefault();
                setIsOpen(true);
              }
            },
            children: [trigger, (caret || !trigger) && !disabled ? _jsx("div", {
              className: "DropdownMenuCarretIconSvg",
              children: _jsx(DownCarrotIcon, {
                size: "s",
                color: color
              })
            }) : null]
          })
        }), _jsx(Portal, {
          container: portalContainer,
          children: _jsx(Content, {
            loop: true,
            side: side,
            sx: _objectSpread(_objectSpread({}, optionsListStyles), {}, {
              maxHeight: optionsContainerMaxHeight || "unset"
            }),
            align: align,
            onFocusOutside: handleFocusOutside,
            children: options.map(function (option) {
              var isMouse = false;
              var Tag = option.href ? "a" : "button";
              return _jsx(Item, {
                onSelect: function onSelect(e) {
                  // Keyboard users need the menu to keep open when they open a modal.
                  // According to a11y regulation, the focus should return to the button that opened the modal once said modal is closed
                  // The only way to do that is by keeping the menu open.
                  // Radix allows us to keep the menu open by adding prevent default to the onSelect prop.
                  // The problem is that the radix menu items interprets a click with a mouse differently from a click with a keyboard
                  // because of that, it only moves focus to the opened modal if the click is done with a keyboard.
                  // on top of that, radix does not pass any property to the onSelect event object that allows us to verify if it was a mouse click or a keyboard click.
                  // so, to fix that, we had to add an onClick listener to grab the pointer type
                  if (option.opensAModal && !isMouse) e.preventDefault();
                  if (isMouse) isMouse = false;
                },
                onClick: function onClick(e) {
                  if (e.nativeEvent.pointerType) isMouse = true;
                },
                asChild: true,
                role: option.href ? "link" : "button",
                children: _jsxs(Tag, {
                  sx: _objectSpread(_objectSpread({}, listItemStyles), {}, {
                    color: option.color || "dt_taro90"
                  }),
                  onClick: option.onClick,
                  href: option.href,
                  children: [option.icon, option.label]
                })
              }, option.label);
            })
          })
        })]
      })]
    })
  );
}
var DropdownMenuTriggerButtonStyles = {
  fontWeight: "600",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  minWidth: "40px",
  minHeight: "40px",
  '&[aria-expanded="true"] .DropdownMenuCarretIconSvg': {
    transform: "rotate(180deg)"
  },
  '&[disabled="true"],  &[disabled]': {
    cursor: "not-allowed",
    opacity: "0.6"
  },
  ".DropdownMenuCarretIconSvg": {
    transition: "transform 0.3s linear",
    marginLeft: "dt_xxs",
    display: "flex",
    alignItems: "center"
  }
};
var optionsListStyles = {
  backgroundColor: "dt_white",
  boxShadow: "0 1px 5px 0px rgba(0, 0, 0, 0.3)",
  marginTop: "dt_xs",
  borderRadius: RAW_cssValue("5px"),
  overflowY: "auto",
  zIndex: 100
};
var listItemStyles = {
  backgroundColor: "transparent",
  "&:hover, &:focus-within": {
    backgroundColor: "dt_blueberry20"
  },
  border: "2px solid",
  borderColor: "transparent",
  whiteSpace: "nowrap",
  fontSize: "16px",
  paddingLeft: "dt_s",
  paddingRight: "dt_xl",
  paddingY: "dt_s",
  minHeight: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "dt_s",
  ":focus:not(:hover)": {
    borderColor: "dt_taro60"
  },
  ":focus": {
    outline: "none"
  },
  // this needs to be last child and not last of type now that we have two different types as children
  "&:not(:last-child)": {
    borderBottom: "1px solid",
    borderBottomColor: "dt_taro30"
  },
  "&:last-child": {
    borderBottomLeftRadius: RAW_cssValue("5px"),
    borderBottomRightRadius: RAW_cssValue("5px")
  },
  "&:first-child": {
    borderTopLeftRadius: RAW_cssValue("5px"),
    borderTopRightRadius: RAW_cssValue("5px")
  }
};